import PageHeader from "components/PageHeader";

const posts = [
  {
    date: "March 15, 2024",
    title: "The Secret Life of Owls",
    excerpt:
      "Discover the fascinating nocturnal behaviors and hunting techniques of these magnificent predators...",
  },
  {
    date: "March 10, 2024",
    title: "Spring Migration Season",
    excerpt:
      "Everything you need to know about the incredible journey birds take during spring migration...",
  },
  {
    date: "March 5, 2024",
    title: "Conservation Success Stories",
    excerpt:
      "How our conservation efforts have helped protect endangered bird species in the region...",
  },
];

const categories = [
  {
    title: "Bird Behavior",
    description:
      "Insights into the fascinating behaviors and social structures of different bird species.",
  },
  {
    title: "Conservation",
    description:
      "Updates on conservation efforts and success stories from around the world.",
  },
  {
    title: "Aviary Life",
    description:
      "Behind-the-scenes stories and updates from our daily operations at Mysher Aviary.",
  },
];

const Blog = () => {
  return (
    <div className="min-h-screen pt-0">
      <PageHeader
        title="Blog"
        subtitle="Latest news, stories, and insights from the bird world"
      />

      <div className="bg-white py-20 max-[768px]:py-[60px]">
        <div className="container">
          <div className="grid grid-cols-2 items-start gap-16 max-[968px]:grid-cols-1 max-[968px]:gap-8">
            <div className="mb-12">
              <h2 className="mb-8 text-4xl font-bold text-primary-blue max-[768px]:text-3xl">
                Recent Articles
              </h2>
              <div className="mt-8 grid grid-cols-1 gap-8">
                {posts.map((post) => (
                  <article
                    key={post.title}
                    className="grid grid-cols-[200px_1fr] overflow-hidden rounded-xl bg-white shadow-[0_4px_15px_rgba(0,0,0,0.1)] transition-transform duration-300 hover:-translate-y-1 max-[968px]:grid-cols-1"
                  >
                    <div className="h-[150px] bg-gradient-to-br from-accent-green to-light-green max-[968px]:h-[200px]" />
                    <div className="p-6">
                      <span className="mb-2 block text-sm text-text-light">
                        {post.date}
                      </span>
                      <h3 className="mb-4 font-semibold text-primary-blue">
                        {post.title}
                      </h3>
                      <p className="mb-0 text-text-light">{post.excerpt}</p>
                      <button
                        type="button"
                        className="font-semibold text-accent-green transition-colors duration-300 hover:text-light-green"
                      >
                        Read More
                      </button>
                    </div>
                  </article>
                ))}
              </div>
            </div>

            <div className="mb-12">
              <h2 className="mb-8 text-4xl font-bold text-primary-blue max-[768px]:text-3xl">
                Categories
              </h2>
              <p className="mb-8 text-lg leading-[1.7] text-text-light">
                Explore our blog categories covering various aspects of bird
                life, conservation, and aviary management.
              </p>

              <div className="mt-8">
                {categories.map((category, index) => (
                  <div
                    key={category.title}
                    className={`mb-8 border-b border-[#e9ecef] pb-8 ${
                      index === categories.length - 1
                        ? "mb-0 border-b-0"
                        : ""
                    }`}
                  >
                    <h3 className="mb-2 font-semibold text-primary-blue">
                      {category.title}
                    </h3>
                    <p className="mb-0 text-text-light">
                      {category.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
